import Icon from '@ant-design/icons';
import { Button, Col, Form, FormInstance, Input, Row } from 'antd';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Link, RouteComponentProps } from 'react-router-dom';
import playerApi from '../../../../apis/PlayerApi';
import LayoutComponent from '../../../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../../../context/CustomContext';
import { Player } from '../../../../model/Entities';
import { ReactComponent as SaveSvg } from '../../../../resources/images/ico-save.svg';
import { ReactComponent as DeleteSvg } from '../../../../resources/images/ico-delete.svg';
import styles from './PlayerPage.module.scss';

class PlayerPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    formRef = React.createRef<FormInstance>();

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            this.setState({ loading: true });
            if (this.props.match.params.id === 'new') {
                await this.new();
            } else {
                await this.get(+this.props.match.params.id);
            }
        } catch (error) {
        } finally {
            this.setState({ loading: false });
        }
    };

    new = async () => {
        const player: Player = {
            firstName: '',
            lastName: '',
        };

        this.setState({ player });
        this.formRef.current!.setFieldsValue(player);
    };

    get = async (id: number) => {
        const player = await playerApi.get(id);

        this.setState({ player });
        this.formRef.current!.setFieldsValue(player);
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        const { player, loading } = this.state;

        return (
            <>
                {this.renderToolbar()}
                <Form ref={this.formRef} colon={false} layout="vertical">
                    <Row gutter={[28, 0]}>
                        <Col xs={24} md={8}>
                            <Form.Item
                                label={<FormattedMessage id="player.edit.first" />}
                                name="firstName"
                                rules={[{ required: true, message: <FormattedMessage id="status.mandatory" /> }]}
                            >
                                <Input maxLength={100} placeholder={player?.firstName} size="large" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={8}>
                            <Form.Item
                                label={<FormattedMessage id="player.edit.last" />}
                                name="lastName"
                                rules={[{ required: true, message: <FormattedMessage id="status.mandatory" /> }]}
                            >
                                <Input maxLength={100} placeholder={player?.lastName} size="large" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <div className={styles.buttons}>
                        <Link to="/admin/players">
                            <Button size="large" className={styles.back}>
                                <FormattedMessage id="player.edit.back" />
                            </Button>
                        </Link>
                        {this.props.match.params.id !== 'new' && (
                            <Button size="large" icon={<Icon component={DeleteSvg} />} className={styles.delete}>
                                <FormattedMessage id="player.edit.delete" />
                            </Button>
                        )}
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            className={styles.save}
                            icon={<Icon component={SaveSvg} />}
                            loading={loading}
                        >
                            <FormattedMessage id="player.edit.save" />
                        </Button>
                    </div>
                </Form>
            </>
        );
    };

    renderToolbar = (): React.ReactElement | undefined => {
        if (this.props.match.params.id === 'new') {
            return (
                <div className={styles.toolbar}>
                    <h1>
                        <FormattedMessage id="player.addtitle" />
                    </h1>
                </div>
            );
        } else {
            return (
                <div className={styles.toolbar}>
                    <h1>
                        <FormattedMessage id="player.edittitle" />
                    </h1>
                </div>
            );
        }
    };

    render() {
        return <LayoutComponent page="edit-player" content={this.renderContent} />;
    }
}
export default injectIntl(PlayerPage);

type ParamsType = { id: string };
interface Props extends RouteComponentProps<ParamsType>, WrappedComponentProps {}

interface State {
    player?: Player;
    loading?: boolean;
}
